var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10.6666V11.1666H6H12H12.5V10.6666V2.66659V2.16659H12H6H5.5V2.66659V10.6666ZM2.83333 13.3333V13.8333H3.33333H10C10.0627 13.8333 10.092 13.849 10.1218 13.8788C10.1508 13.9078 10.1667 13.9367 10.1667 13.9999C10.1667 14.0632 10.1508 14.0921 10.1218 14.121C10.092 14.1508 10.0627 14.1666 10 14.1666H3.33333C3.10032 14.1666 2.91315 14.0895 2.74489 13.9217C2.57704 13.7534 2.5 13.5663 2.5 13.3333V4.66658C2.5 4.60388 2.51577 4.57459 2.54555 4.54481C2.57453 4.51583 2.60343 4.49992 2.66667 4.49992C2.72948 4.49992 2.75899 4.51564 2.78844 4.54481C2.81761 4.57426 2.83333 4.60377 2.83333 4.66658V13.3333ZM6 11.4999C5.76687 11.4999 5.58 11.4228 5.41222 11.255C5.24382 11.0866 5.16667 10.8995 5.16667 10.6666V2.66659C5.16667 2.43371 5.24382 2.24654 5.41222 2.07814C5.58 1.91036 5.76687 1.83325 6 1.83325H12C12.233 1.83325 12.4202 1.9103 12.5884 2.07814C12.7563 2.2464 12.8333 2.43357 12.8333 2.66659V10.6666C12.8333 10.8996 12.7563 11.0868 12.5884 11.255C12.4202 11.4229 12.233 11.4999 12 11.4999H6Z",
    fill: "#AFAFAF",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconWhite);
export default __webpack_public_path__ + "static/media/copy-icon-white.1d3b6d57907ec9bfffd5096d99b84c50.svg";
export { ForwardRef as ReactComponent };